<template>
<section class="border-gray-800 border-t p-3">
  <h4 class="text-white text-sm font-bold uppercase mb-3 inline">Team</h4>
  <span v-if="$page.props.flash.pop_up_team_message" class="ml-2 text-green-700">{{ $page.props.flash.pop_up_team_message }}</span>
  <span v-for="error in getErrors('email_for_invite')"
  class="ml-2 text-red-600">{{ error }}</span>
  <div class="flex">
    <div class="w-2/3">
      <label for="invite_email">Invite user via Email address</label>
      <input class="input-black" id="invite_email" type="email" v-model="form.email">
    </div>
    <div class="w-1/3 flex flex-col pl-4">
      <button v-if="!form.processing" @click="sendInvitation" class="btn btn-gradient mt-2 mb-2 float-right mt-auto">
          <i class="add-user mr-2"></i>Send invitation
      </button>
      <button v-else class="btn btn-gradient mt-2 mb-2 float-right mt-auto btnpx-10"><Spinner/></button>
    </div>
  </div>
  <div class="team-list">
    <span class="team-list-item flex justify-between" v-for="user in users">
      <span>{{ user.first_name }} {{ user.last_name }} {{ user.email }}</span>
      <button @click="() =>deleteUserFromProvider(user.id)"><i class="trash"></i></button>
    </span>
  </div>
</section>
</template>


<script>
import Spinner from '@/UI/Spinner'
import { getErrors } from '@/Pages/GlobalHelpers'

export default {
  components: {
    Spinner
  },
  props: ['toggleModal', 'provider_id'],
  data(){
    return{
      form: this.$inertia.form({
        _method: 'POST',
        email: null,
      }),
      formProviderIdentifier: null,
      users: [],
      delete_from_provider_form: this.$inertia.form({
        _method: 'POST',
        user_id: null,
      }),
      deleteFromProviderFormProviderIdentifier: null,
    }
  },
  watch: {
    provider_id:function(newState, oldState){
      const providerIdentifier = (newState != null) ? this.$page.props.providers.data
      .filter(el => el.id == newState)[0].identifier : null;
      this.formProviderIdentifier = providerIdentifier;
      this.deleteFromProviderFormProviderIdentifier = providerIdentifier;
      if(newState)
      {
        this.users = this.$page.props.providers.data.filter(el=>el.id == newState)[0].users;
      } else {
        this.users = [];
      }
    }
  },
  methods: {
    getErrors:getErrors,
    sendInvitation(){
      this.form.post(route('user.invite-editor-to-provider', this.formProviderIdentifier), {
        onSuccess: (message) => {
          this.form.email = null;
          this.users = this.$page.props.providers.data.filter(el=>el.id == this.provider_id)[0].users;
        },
        onError: (err) => {
          this.form.email = null;
        }
      });
    },
    deleteUserFromProvider(user_id){
      this.delete_from_provider_form.user_id = user_id;
      this.delete_from_provider_form.post(route('user.delete-editor-from-provider', this.deleteFromProviderFormProviderIdentifier), {
        onSuccess: (message) => {
          this.delete_from_provider_form.user_id = null;
          this.users = this.$page.props.providers.data.filter(el=>el.id == this.provider_id)[0].users;
        },
        onError: (err) => {
          this.delete_from_provider_form.user_id = null;
          this.toggleModal();
        }
      });
    }
  }
}
</script>